const anonymousRoutesPatterns = [
    /employees\/exemptions\/[a-f0-9]{32}/,
    /\/reasons(\?|$)/,
];

export const backendRouteNeedAuthentication = (routePath) => (
    false === anonymousRoutesPatterns.some(regex => routePath.match(regex))
);
